import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import ChangeOrderGrid from '../../../features/cfi/change-order-grid/components/ChangeOrderGrid';
import {ChangeOrderStatus} from '../../../types/enums';

export default function DealerChangeOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle("Pending Dealer")
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<ChangeOrderGrid changeOrderStatus={ChangeOrderStatus.Dealer} />
			</div>
		</React.Fragment>
	)
} 
